<a [routerLink]="link" (click)="setReturn()">
  <ng-container *ngIf="!hasData">
    Add
    <span class="govuk-visually-hidden"> for</span>
  </ng-container>
  <ng-container *ngIf="hasData"> Change</ng-container>
  <span class="govuk-visually-hidden">{{ explanationText }}</span>
</a>
